import { createFileRoute } from '@tanstack/react-router'

import { CarrierPage } from '#/modules/fmcsa/carrier-page'

export const Route = createFileRoute('/_shell/fmcsa-carriers/$usdot')({
  component: function CarrierRoute() {
    const { usdot } = Route.useParams()
    return <CarrierPage usdot={usdot} />
  },
})
